<template>
  <footer class="footer" id="footer">
    <div class="footer__container">
        <div class="footer__top">
            <div class="left" v-if="options['Footer']">
              <div class="mini__title" data-animate="slideUp">{{ options['Footer']['Footer mini title']}}</div>
              <div class="title" data-animate="slideUp">{{ options['Footer']['Footer title']}}</div>
              <div class="desc" data-animate="slideUp">{{ options['Footer']['Footer description']}}</div>
              <div class="wrapper">
                <template v-for="item in options['Footer']['Footer address']">

                  <img :src="`${this.$store.state.base_directory}${item.image.replace(/^public\//, '')}`" alt="Изображение">
                  <a :href="item.link" class="address" target=”_blank”> 
                    <svg width="18.000000" height="21.728027" viewBox="0 0 18 21.728" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs/>
                      <path id="Vector" d="M9 21.72L2.63 15.36C1.37 14.1 0.52 12.5 0.17 10.75C-0.18 9 0 7.2 0.68 5.55C1.36 3.91 2.51 2.5 3.99 1.51C5.47 0.52 7.21 0 9 0C10.78 0 12.52 0.52 14 1.51C15.48 2.5 16.63 3.91 17.31 5.55C17.99 7.2 18.17 9 17.82 10.75C17.47 12.5 16.62 14.1 15.36 15.36L9 21.72ZM13.95 13.94C14.92 12.97 15.59 11.72 15.86 10.36C16.13 9 15.99 7.6 15.46 6.32C14.93 5.04 14.04 3.94 12.88 3.18C11.73 2.41 10.38 2 9 2C7.61 2 6.26 2.41 5.11 3.18C3.95 3.94 3.06 5.04 2.53 6.32C2 7.6 1.86 9 2.13 10.36C2.4 11.72 3.07 12.97 4.05 13.94L9 18.89L13.95 13.94ZM9 11C8.46 11 7.96 10.78 7.58 10.41C7.21 10.03 7 9.53 7 9C7 8.46 7.21 7.96 7.58 7.58C7.96 7.21 8.46 7 9 7C9.53 7 10.03 7.21 10.41 7.58C10.78 7.96 11 8.46 11 9C11 9.53 10.78 10.03 10.41 10.41C10.03 10.78 9.53 11 9 11Z" fill="#FFFFFF" fill-opacity="1.000000" fill-rule="nonzero"/>
                    </svg>
                    {{item.text}}
                  </a>
                </template>
              </div>
            </div>
            <div class="right">
              <form action="">
                <div class="flex__input">
                  <div>
                    <input type="text" placeholder="Name*" v-model="v$.valueField.name.$model" :class="{ 'error': v$.valueField.name.$invalid && submitted }">
                    <div class="alert" v-if="v$.valueField.name.$invalid && submitted">Enter name</div>
                  </div>
                  <div>
                  <input type="text" placeholder="Company name*" v-model="v$.valueField.company_name.$model" :class="{ 'error': v$.valueField.company_name.$invalid && submitted }">
                  <div class="alert" v-if="v$.valueField.company_name.$invalid && submitted">Enter company name</div>
                </div>
                  
                  
                </div>
                <div class="flex__input">
                  <div>
                    <input type="text" placeholder="Phone number*" v-model="v$.valueField.phone.$model" :class="{ 'error': v$.valueField.phone.$invalid && submitted }">
                    <div class="alert" v-if="v$.valueField.phone.$invalid && submitted">Enter your phone number</div>
                  </div>
                  <div>
                    <input type="email" placeholder="E-mail" v-model="v$.valueField.email.$model" :class="{ 'error': v$.valueField.email.$invalid && submitted }">
                  </div>
                </div>
                <input type="text" placeholder="Full Address" v-model="v$.valueField.full_address.$model" :class="{ 'error': v$.valueField.full_address.$invalid && submitted }">
                <textarea placeholder="Message" v-model="v$.valueField.message.$model" :class="{ 'error': v$.valueField.message.$invalid && submitted }"></textarea>
                <div class="button__wrapper">
                  <ButtonOrange style="width: 140px;" class="white" @click="submitForm">Get In Touch</ButtonOrange>
                  <ul v-if="options['Footer']">
                    <li v-for="item in options['Footer']['Social list']">
                      <a :href="item.text" target=”_blank”>
                        <img :src="`${this.$store.state.base_directory}${item.image.replace(/^public\//, '')}`" alt="Изображение">
                      </a>
                    </li>
                  </ul>
                </div>
              </form>
            </div>
        </div>
        <div class="footer__bottom">
          <div class="pages__link" v-if="options['Footer']">
              <a :href="item.link" v-for="item in options['Footer']['Footer page links']" data-animate="slideUp">{{ item.text }}</a>
          </div>
          <div class="copyright" v-if="options['Footer']" v-for="item in options['Footer']['Footer copyright']">
            <div>{{ item.textl}}</div>
            <div style="display: flex; align-items: center; gap: 8px; position: relative;">
              <img :src="`${this.$store.state.base_directory}${item.image.replace(/^public\//, '')}`" alt="Изображение">
              <a :href="item.text" target=”_blank”></a>
            </div>
          </div>
        </div>
    </div>
  </footer>
</template>

<script>
import axios from "axios";
import ButtonOrange from "../UI/ButtonOrange.vue";
import { useVuelidate } from '@vuelidate/core'
import { required, email} from '@vuelidate/validators';
export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    ButtonOrange,
  },
  data() {
    return {
      valueField: {
                  name: '',
                  company_name: '',
                  email: '',
                  phone: '',
                  full_address: '',
                  message: ''
              },
      submitted: false,
      request: false,
    }
  },
  validations() {
        return {
            valueField: {
                name: { required },
                company_name: { required },
                phone: { required },
                email: { email },
                full_address: { },
                message: { },
            }
        }
    },
    methods: {
      submitForm(e){
              e.preventDefault();
              this.submitted = true;
              if(this.request){
                  return false;
              }
              this.request = true;
              this.v$.$touch();
              if (this.v$.valueField.$invalid) {
                  this.request = false;
              } else {
   
                  const formData = { ...this.valueField };
                  if (this.$route.name === 'product') {
                        formData.slug = this.$route.params.slug;
                  }
                  if (this.$route.name === 'ugm-machine') {
                        formData.ugm_sku = this.$route.params.slug;
                  }
                  axios.post('/submit-form-footer', formData)
                  .then(response => {
                  })
                  .catch(error => {
                  })
                  .finally(() => {
                  this.request = false; // Разблокировать запрос
                  });
              }
      }
    },
    computed: {
    options() {
            return this.$store.state.options;
        },
    }
}
</script>

<style scoped>
.copyright > div a{
position: absolute;
left: 0;
top: 0;
width: 100%;
height: 100%;
}
.alert{
color: red;
font-size: 16px;
font-weight: 400;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
opacity: 0.8;
padding-top: 6px;
}
.pages__link{
display: flex;
justify-content: space-between;
border-top: 1px solid rgba(222, 230, 234, 0.2);
border-bottom: 1px solid rgba(222, 230, 234, 0.2);
padding: 32px 0;
gap: 24px;
flex-wrap: wrap;
}
.pages__link a{
cursor: pointer;
/* Tabs/T1: 13px Medium */
color: rgb(255, 255, 255);
font-size: 13px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
}
.copyright{
display: flex;
justify-content: space-between;
/* Tabs/T1: 13px Medium */
color: rgb(255, 255, 255);
font-size: 13px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
opacity: 0.5;
padding-top: 12px;
align-items: center;
}
.copyright img{
max-height: 40px;
}
.button__wrapper ul{
display: flex;
gap: 12px;
}
.button__wrapper ul a{
display: flex;
align-items: center;
justify-content: center;
width: 24px;
height: 24px;
border-radius: 100%;
background: rgb(255, 183, 16);
}
.button__wrapper{
display: flex;
justify-content: space-between;
align-items: center;
}
.right{
max-width: 640px;
width: 100%;
}
form{
display: flex;
gap: 40px;
flex-direction: column;
}
.flex__input{
display: flex;
gap: 32px;
}
.flex__input > div{
width: 100%;
}
input{
width: 100%;
background-color: transparent; /* Прозрачный фон */
border: none;                 /* Убираем все бордеры */
border-bottom: 2px solid rgba(222, 230, 234, 0.2); /* Полоска снизу */
outline: none;                /* Убираем обводку при фокусе */
color: #000;                  /* Цвет текста */
font-size: 16px;              /* Размер шрифта (настраиваемый) */
padding: 5px 0; 

color: rgb(255, 255, 255);
font-size: 16px;
font-weight: 400;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
}
input.error{
border-bottom: 2px solid red;
}
input::placeholder {
color: rgb(255, 255, 255); 
opacity: 0.6;
}
textarea{
width: 100%;
background-color: transparent; /* Прозрачный фон */
border: none;                 /* Убираем все бордеры */
border-bottom: 2px solid rgba(222, 230, 234, 0.2);; /* Полоска снизу */
outline: none;                /* Убираем обводку при фокусе */
color: #000;                  /* Цвет текста */
font-size: 16px;              /* Размер шрифта (настраиваемый) */
padding: 5px 0;   
resize: none;

color: rgb(255, 255, 255);
font-size: 16px;
font-weight: 400;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
height: 105px;
}
textarea.error{
border-bottom: 2px solid red;
}
textarea::placeholder {
color: rgb(255, 255, 255); 
opacity: 0.6;
}
footer {
  background: rgb(5, 5, 5);
  padding-top: 120px;
  padding-bottom: 24px;
}
.footer__top{
  display: flex;
  justify-content: space-between;
  padding-bottom: 181px;
  gap: 24px;
}
.footer__top .left{
    max-width: 409px;
}
.left .mini__title{
  color: rgb(255, 255, 255);
  font-size: 13px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  padding-bottom: 10px;
}
.left .title{
  color: rgb(255, 255, 255);
  font-size: 44px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  opacity: 0.9 !important;
}
.left .desc{
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  opacity: 0.7;
  padding-bottom: 24px;
  padding-top: 24px;
}
.left .wrapper{
  display: flex;
  align-items: center;
  gap: 26px;
}
.left .wrapper .address{
  display: flex;
  align-items: center;
  gap: 11px;
  color: rgb(255, 255, 255);
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
}
.left .wrapper img{
  max-width: 42.45px;
  max-height: 26px;
}
@media (max-width: 1024px) { 
  .left .title{
    font-size: 32px;
  }
}
@media (max-width: 768px) { 
  .left .title{
    font-size: 22px;
  }
  .left .desc{
    font-size: 18px;
  }
  .right{
    max-width: unset;
  }
  .pages__link a{
    width: calc((100%/3) - 16px);
    justify-content: unset;
  }
  .footer{
    padding-top: 60px;
  }
  .footer__top{
    flex-direction: column;
    padding-bottom: 40px;
  }
  .footer__top .left{
    max-width: unset;
  }
  .flex__input{
    flex-direction: column;
    gap: 40px;
  }
}
@media (max-width: 580px) { 
  .pages__link a{
    width: calc((100%/2) - 16px);
  }
}
</style>